const initializeGA = (userEmail: string) => {
  if (process.env.NODE_ENV !== "production") return;

  const { REACT_APP_GTAG_ID } = process.env;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${REACT_APP_GTAG_ID}`;
  document.body.appendChild(script);

  window.dataLayer = window.dataLayer || [];

  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", REACT_APP_GTAG_ID, {
    user_email: userEmail,
  });
};

export default initializeGA;
